define("shared/components/shared/ui/button", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/debug", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _debug, _object, _utils, _component2, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!  template-lint-disable require-button-type }}
  {{!  template-lint-disable @latermedia/later-template-linting/use-other-component }}
  <button
    aria-disabled={{or this.isRunning @isDisabled}}
    {{button variant=@variant size=@size additional=@additional class=(concat @class this.disabledClass)}}
    {{on "click" this.handleClick}}
    ...attributes
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{#if (and this.isRunning @runningText)}}
        {{@runningText}}
      {{else}}
        {{this.verifiedText}}
      {{/if}}
    {{/if}}
  </button>
  */
  {
    "id": "WMdYY4/R",
    "block": "[[[11,\"button\"],[16,\"aria-disabled\",[28,[37,0],[[30,0,[\"isRunning\"]],[30,1]],null]],[17,2],[4,[38,1],null,[[\"variant\",\"size\",\"additional\",\"class\"],[[30,3],[30,4],[30,5],[28,[37,2],[[30,6],[30,0,[\"disabledClass\"]]],null]]]],[4,[38,3],[\"click\",[30,0,[\"handleClick\"]]],null],[12],[1,\"\\n\"],[41,[48,[30,8]],[[[1,\"    \"],[18,8,null],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,0,[\"isRunning\"]],[30,7]],null],[[[1,\"      \"],[1,[30,7]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[30,0,[\"verifiedText\"]]],[1,\"\\n\"]],[]]]],[]]],[13]],[\"@isDisabled\",\"&attrs\",\"@variant\",\"@size\",\"@additional\",\"@class\",\"@runningText\",\"&default\"],false,[\"or\",\"button\",\"concat\",\"on\",\"if\",\"has-block\",\"yield\",\"and\"]]",
    "moduleName": "shared/components/shared/ui/button.hbs",
    "isStrictMode": false
  });

  let ButtonComponent = (_class = class ButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "isRunning", _descriptor, this);

      _defineProperty(this, "promiseHandler", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.isDisabled || !this.args.promise) {
            return;
          }

          try {
            this.isRunning = true;
            yield this.args.promise.unlinked().perform();
          } finally {
            this.isRunning = false;
          }
        }
      }), {
        drop: true
      }, "promiseHandler", null));
    }

    get isDisabled() {
      return this.args.isDisabled || false;
    }

    get verifiedText() {
      (false && !((0, _utils.isPresent)(this.args.text)) && (0, _debug.assert)('The `@text` argument is required with inline usage', (0, _utils.isPresent)(this.args.text)));
      return this.args.text;
    }

    get disabledClass() {
      if (this.isDisabled || this.isRunning) {
        return ' o--btn--disabled';
      }

      return '';
    }

    handleClick(event) {
      if (this.args.promise || this.args.onClick) {
        event.preventDefault();
      }

      if (this.isDisabled || this.isRunning) {
        return;
      }

      if (this.args.promise) {
        this.promiseHandler.perform();
        return;
      }

      if (this.args.onClick) {
        this.args.onClick(event);
        return;
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isRunning", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype)), _class);
  _exports.default = ButtonComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ButtonComponent);
});